export const selectAppBasicInfo = ({ app }) => app.basicInfo;

export const selectAppFullProfile = ({ app }) => app.fullProfile;

export const selectRenewalFee = ({ app }) => (app.basicInfo || {}).renewalFee;
